import { bootstrapApplication } from '@angular/platform-browser';

// eslint-disable-next-line import/no-deprecated
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
